<template>
  <form @submit.prevent="submit" autocomplete="off">
    <t-modal-section :title="$t('Edit Device Exception')" class="mb-3">
      <b-row>
        <b-col sm="12" md="12" lg="6">
          <b-form-group
            :label="$t('Exception Name')"
            label-for="exception_name"
            :state="$validateState($v.form.name)"
          >
            <b-form-input
              autofocus
              data-test-id="modal-inline-edit-device-exception-name"
              :state="$validateState($v.form.name)"
              id="exception_name"
              @blur="setValidationInput('name', $event.target.value)"
              :placeholder="$t('For example, Exception for Sales users')"
              :value="this.item.name"
            />

            <template #invalid-feedback>
              <p
                v-if="
                  $v.form.name.$dirty &&
                  $v.form.name.required &&
                  !$v.form.name.minLength
                "
              >
                {{
                  $t("X must be at least X characters long.", {
                    field: $t("Exception Name"),
                    length: $v.form.name.$params.minLength.min,
                  })
                }}
              </p>
              <p v-if="!$v.form.name.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>

        <b-col sm="12" md="12" lg="6">
          <b-form-group
            :label="$t('Description (optional)')"
            label-for="exception_description"
            :state="$validateState($v.form.description)"
          >
            <b-form-input
              autofocus
              data-test-id="modal-inline-edit-device-exception-description"
              :state="$validateState($v.form.description)"
              id="exception_description"
              @blur="setValidationInput('description', $event.target.value)"
              :placeholder="$t('Exception Description')"
              :value="this.item.description"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </t-modal-section>
  </form>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";

import TModalSection from "@/components/TModalSection";

export default {
  components: {
    TModalSection,
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
      },
      item: {},
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(5),
      },
      description: {},
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("deviceExceptions", ["updateDeviceException"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let formData = this.form;
        let body = Object.keys(formData).reduce((acc, key) => {
          acc[`${key}`] =
            formData[`${key}`] === "" && key !== "description"
              ? null
              : formData[`${key}`];
          return acc;
        }, {});
        const response = await this.updateDeviceException({
          id: this.item.id,
          body,
        });
        this.$store.commit("deviceExceptions/updateDeviceException", response);
        if (response.code === 200) {
          this.displayToast({
            title: this.$t("Success"),
            message: this.$t("Updated"),
            duration: 2000,
            variant: "success",
          });
          this.showModal(false);
        }
      }
    },
  },
  computed: {
    ...mapGetters("modal", ["modalData"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("deviceExceptions", ["deviceExceptions"]),
  },
  created() {
    this.item = this.modalData.item;
    this.userAction(this.submit);
  },
};
</script>
